import { NewContact, useChatStore } from "@/entities/chat";
import { Contact } from "@/entities/contact";
import { formatPhone } from "@/shared/ui";
import { useState } from "react";
import { Badge, Button, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export interface ContactDetailsProps {
    selectedContact: Contact | null;
    chatId: string | undefined;
    isAdmin: boolean;
    handleSetAdmin: (userId: string) => void;
    createChat: (firstName: string, lastName: string, phone: string) => void;
}


const isAdminContact = (roles: string[]) => {
    return roles.includes("ADMIN")
}

export const ContactDetails = ({ selectedContact, chatId, isAdmin, handleSetAdmin, createChat, }: ContactDetailsProps) => {
    const navigate = useNavigate();
    const user = selectedContact?.user
    const [showNewChatModal, setShowNewChatModal] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleAddContact = (contact: NewContact) => {
        // addNewChat(contact);
        setShowModal(false);
        // onHide();
    };


    if (!selectedContact) return (
        <div className="text-muted empty-state">Выберите контакт</div>
    );

    return (
        <div className="details-wrapper" >
            <div className="mb-3 d-flex justify-content-md-start justify-content-center">
                {user?.avatarUrl ? (
                    <Image
                        src={user.avatarUrl}
                        roundedCircle
                        width={100}
                        height={100}
                        style={{ objectFit: "cover" }}
                    />
                ) : (
                    <div
                        style={{
                            width: 100,
                            height: 100,
                            borderRadius: "50%",
                            backgroundColor: "#6c757d",
                            color: "white",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: "bold",
                            fontSize: 40,
                        }}
                    >
                        {selectedContact.firstName?.[0]?.toUpperCase() || "?"}
                    </div>
                )}
            </div>

            <h3 className="details-name">
                <div> {selectedContact.firstName || "—"}</div>
                <div> {selectedContact.lastName || "—"}</div>
            </h3>


            <div className="d-flex flex-column" style={{ maxWidth: 250 }} >
                {isAdmin && user && !isAdminContact(user.roles || []) && (
                    <Button
                        size="sm"
                        variant="outline-secondary"
                        className="mt-1"
                        onClick={() => handleSetAdmin(user._id)}
                    >
                        Назначить администратором
                    </Button>
                )}

                <Button
                    size="sm"
                    variant="outline-secondary"
                    className={!isAdmin ? "mt-3" : "mt-2"}
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        if (chatId) {
                            useChatStore.getState().selectChatId(chatId, navigate)
                        } else {
                            if (
                                selectedContact.user?.phone
                            ) {
                                createChat(selectedContact.firstName || "", selectedContact.firstName || "", selectedContact.user?.phone)
                            }
                        }

                    }}
                >
                    Перейти в чат
                </Button>
            </div>

            {/* <div className="details-section mt-3">
                <h5>Данные контакта</h5>
                <p><span>Имя:</span> {selectedContact.firstName}</p>
                <p><span>Фамилия:</span> {selectedContact.lastName || "—"}</p>
            </div> */}

            <div className="details-section mt-4">
                <h5>Данные пользователя</h5>

                <p><span>Имя:</span> {user?.firstName || "—"}</p>
                <p><span>Фамилия:</span> {user?.lastName || "—"}</p>
                <p><span>Телефон:</span> {formatPhone(user?.phone)}</p>

                <p>
                    <span>Дата регистрации:</span>{" "}
                    {user ? new Date(user.createdAt).toLocaleString() : "-"}
                </p>

                <p>
                    <span>Статус:</span>
                    {
                        user ?
                            <Badge className="ms-2"
                                bg={user?.status === "REGISTERED" ? "success" : "warning"}>
                                {user?.status === "REGISTERED" ? "Зарегистрирован" : "Приглашён"}
                            </Badge> : "-"
                    }
                </p>

                <p>
                    <span>Роль:</span>
                    {
                        user ?
                            isAdminContact(user?.roles || []) ? " Админ" : " Пользователь"
                            : "-"}
                </p>
            </div>

            {/* <AddContactModal
        show={showNewChatModal}
        onHide={() => setShowNewChatModal(false)}
        initialData={{firstName: selectedContact.firstName || "", lastName: selectedContact.lastName || "", phone: selectedContact.user?.phone}}
        
                onSubmit={(newContact) => {
                  useChatStore.getState().addNewChat(newContact)
                    .catch(e => console.error(e)
                    )
                }}
      /> */}
        </div>
    );
};
